import { gql } from "@apollo/client";
import { actionFragment, clientFragment, contactFragment, CourseFragment } from "./fragments";

export const GET_INDIVIDUAL_CLIENTS = gql`
  query individualClients($queries: IndividualsClientsFetchInput) {
    results: individualClients(queries: $queries) {
      countTotal
      data {
        _id
        isDeleted
        uid
        contact {
          ...contactFragment
        }
      }
    }
  }
  ${contactFragment}
`;

export const GET_INDIV_CLIENTS_REF_ADDRESSES = gql`
  query individualClientRefAddresses($queries: RefAddressFetchInput) {
    results: individualClientRefAddresses(queries: $queries) {
      countTotal
      currentPage
      totalPages
      data {
        _id
        clientID
        firstname
        lastname
        phoneNumber
        email
        address {
          address
          place_id
        }
      }
    }
  }
`;

export const GET_ALL_COURSES = gql`
  query courses($queries: CourseFetchInput) {
    results: courses(queries: $queries) {
      countTotal
      currentPage
      data {
        _id
        uid
        isIndividual
        createdAt
        startDate
        endDate
        status
        vehicleType
        driver {
          driver_UID
          driver_firstname
          driver_lastname
          driver_profile_picture
        }
        conveyor {
          conveyor_UID
          conveyor_firstname
          conveyor_lastname
          conveyor_profile_picture
        }
        client {
          ...clientFragment
        }
        individualClient {
          _id
          contact {
            ...contactFragment
          }
        }
        actions {
          ...actionFragment
        }
      }
    }
  }
  ${clientFragment}
  ${actionFragment}
  ${contactFragment}
`;

export const GET_COURSE_BY_ID = gql`
  query course($id: ID!) {
    results: course(id: $id) {
      _id
      uid
      isIndividual
      createdAt
      startDate
      endDate
      driver {
        driver_UID
        driver_firstname
        driver_lastname
      }
      client {
        ...clientFragment
      }
      individualClient {
        _id
        contact {
          ...contactFragment
        }
      }
      actions {
        ...actionFragment
      }
    }
  }
  ${clientFragment}
  ${actionFragment}
  ${contactFragment}
`;

export const GET_COURSE = gql`
  query course($id: ID!) {
    results: course(id: $id) {
      ...CourseFragment
    }
  }
  ${CourseFragment}
`;

export const GET_COURSE_TASK_TO_EXPORT = gql`
  query courseTasksToExport($queries: CourseToExportInput!) {
    courseTasksToExport(queries: $queries) {
      ...CourseFragment
    }
  }
  ${CourseFragment}
`;

export const GET_CLIENTS = gql`
  query allClients($queries: ClientsFetchQueries) {
    allClients(queries: $queries) {
      code
      error
      message
      data {
        _id
        reference
        updatedAt
        type
        executionDate
        executionTime
        status
        address {
          country
          city
          region
          address
          additional_address
          location {
            latitude
            longitude
          }
          place_id
        }
        startTime
        endTime
        items {
          code
          status
          description
        }
      }
      countTotal
      currentPage
      totalPages
    }
  }
`;

export const COURSE_BADGES = gql`
  query badges($queries: BadgeInput) {
    badges(queries: $queries) {
      count
    }
  }
`;
